export default __webpack_public_path__ + "static/media/DK.6feb849c.svg";